export class SubscriberBackendShopCredentialsModel {
	key: string = "";
	password: string = "";

	constructor(s?:Partial<SubscriberBackendShopCredentialsModel>) {
		Object.assign(this, s);
	}
}
